import React from 'react';

const TwoColumnSidebar = () => {
	return <div></div>;
};

export default TwoColumnSidebar;
